import React from 'react';
import '../../Default.css';


function Accident() {
    return (
      <>
        <div className="page-title">
          Wypadek lub nieszczęśliwe zdarzenie
        </div>
        <div className='boxes-contener'>
          <div className='copyright-tekst'>tekst zaczerpnięty ze strony internetowej MSZ</div>
          <div className='text-box'>
            <div className='paragraf'>
                Wszelkie wypadki (m.in. komunikacyjne, kradzież, rozbój, naruszenie nietykalności) należy bezzwłocznie zgłosić właściwym portugalskim służbom:
            </div>
            <div className='text-box-accent'>
                Numer alarmowy – 112 <br/>
                Policja turystyczna w Lizbonie 218 804 030
            </div>
          </div>
          <div className='text-box'>
            <div className='text-box-header'>Informacje od MSZ</div>
            <a href="https://www.google.com/maps/place/Foz+Palace/@38.7158345,-9.1424917,15z/data=!4m6!3m5!1s0xd1933810f01389d:0x109fdbc4507a4b8b!8m2!3d38.7158345!4d-9.1424917!16s%2Fm%2F07n6797?shorturl=1">
                Lizbona - Palácio Foz, Praça dos Restauradores, tel. +351 218804030
            </a>
            <a href="https://www.google.com/maps/place/PSP+-+Esquadra+de+Turismo/@38.7097264,-9.1276921,18.25z/data=!4m6!3m5!1s0xd19353edfd1fa85:0x9e2f8d3ab81f6f9a!8m2!3d38.7092535!4d-9.1267433!16s%2Fg%2F11t_ym1_jv?entry=tts&shorturl=1">
                Lizbona - Terminal statków wycieczkowych (Terminal de Cruzeiros), Edifício SW, Doca, R. Jardim do Tabaco, tel. +351 218804030
            </a>
            <a href="https://www.google.com/maps/place/PSP-+Esquadra+de+Turismo+de+Cascais/@38.6969013,-9.4194539,17.75z/data=!4m6!3m5!1s0xd1ec5dadb110f0f:0x8e63a20c858a0a4a!8m2!3d38.6977153!4d-9.4190869!16s%2Fg%2F11gsbhchph?entry=tts&shorturl=1">
                Cascais - Largo Mte. Henrique Anjos, tel. +351 214814067
            </a>
          </div>
          <div className='text-box'>
            <div className='text-box-header'>Narodowa Gwardia Republikańska</div>
            <p>Lizbona - +351 213 252 500</p>
            <p>Setúbal - +351 265 242 500</p>
            <p>Santarém - +351 243 300 091</p>
          </div>
          <div className='text-box'>
            <div className='text-box-header'>Policja Morska (Polícia Marítima)</div>
            <p>Lizbona - +351 918 498 025</p>
            
            <a href='https://www.psp.pt/Pages/onde-estamos.aspx'>
                Wyszukiwarka posterunków policji (PSP)
            </a>
            <a href='https://www.gnr.pt/contactos.aspx'>
                Wyszukiwarka posterunków Narodowej Gwardii Republikańskiej (GNR)
            </a>
          </div>
          <div className='text-box'>
            <div className='text-box-header'>Pomoc medyczna</div>
            <div className='paragraf'>
                W przypadku potrzeby uzyskania pomocy medycznej zaleca się kontakt telefoniczny z linią SNS24 przed przyjazdem do jednostki służby zdrowia (szpitala lub ośrodka zdrowia). Linia działa 24 godziny na dobę, 7 dni w tygodniu (obsługa w j. portugalskim, angielskim i hiszpańskim oraz w portugalskim języku migowym za pośrednictwem połączenia wideo). 
            </div>
            <div className='text-box-accent'>
                SNS24 – 808 24 24 24
            </div>
          </div>
        </div> 
      </>
    );
}

export default Accident;
